import options from './emulator-details.component';

export default {
    selector: "dtEmulatorDetailsPage",
    options
};
